import React from 'react';
import styles from './style.module.scss';

function TitleWithDashedLine({ text, as = "div", className = "", ...props }) {
    const Component = as;
    return (
        <div className={`${styles.container} ${className}`} {...props}>
            <Component>{text}</Component>
            <div className={styles.line} />
        </div>
    );
}


export default TitleWithDashedLine;
